module.exports = __webpack_public_path__ + "img/chris_giga_zp2.b007e594.jpg";